import React, { useEffect, useState, useRef, useCallback } from "react";
import pako from "pako";
import ProgressLoading from "src/control-components/loader/loader_with_text";
import DateTimeHelper from "../../../../helper/date-time-helper";
import { MaskFormatted } from "src/helper/mask-helper";
import { puppeteerService } from "src/services/puppeteerPdfService";
import moment from "moment";
import dummyImg from "../../../../assets/images/dummy-img.png";
import noPlan from "../../../../assets/images/undraw_blank_canvas_re_2hwy 1.png"

function DiagnosisEducationPDF({
  isPrintPDF,
  setIsPrintPDF,
  onError,
  clientDetail,
  currentInsurance,
  minDiagnoseName,
  clinicDetails,
  htmlContentPdf, 
  isDiagnosis
}) {
  const _elementRef = useRef<HTMLDivElement | null>(null);
  const [isDocumentRendered, setIsDocumentRendered] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleContentRendered = useCallback(() => {
    setIsDocumentRendered(true);
  }, []);

  useEffect(() => {
    if (htmlContentPdf || clientDetail) {
      handleContentRendered();
    }
  }, [htmlContentPdf, clientDetail]);
  

  let newObj = clinicDetails?.zip;
  let intZip = newObj !== undefined && newObj.slice(0, 5);
  let lastZip = newObj !== undefined && newObj.slice(5);
  let Phone = MaskFormatted(
    clinicDetails ? clinicDetails?.phone : "",
    "(999) 999-9999"
  );

  useEffect(() => {
    if (isPrintPDF && isDocumentRendered) {
      handleGeneratePDF();
    }
  }, [isPrintPDF, isDocumentRendered]);

  const handleGeneratePDF = useCallback(async () => {
    try {
      const styles = Array.from(document.styleSheets)
        .map((styleSheet) => {
          try {
            return Array.from(styleSheet.cssRules)
              .map((rule) => rule.cssText)
              .join("");
          } catch {
            return "";
          }
        })
        .join("\n");

      const element = _elementRef.current;
      const metaD = {
        clientName: `${clientDetail?.lName}, ${clientDetail?.fName}`,
        dob: DateTimeHelper.formatDatePickerString(clientDetail?.dob),
        insurance:
          currentInsurance?.insuranceName &&
          currentInsurance?.insuranceName.split("-")[1]
            ? `${currentInsurance?.insuranceName.split("-")[1]} - ${
                currentInsurance?.policyNumber
              }`
            : "",
      };
      if (!element) {
        throw new Error("Document content is not ready.");
      }

      const formattedElement = {
        html: element.outerHTML,
        title: "Diagnosis Education PDF",
        author: "Notenetic Team",
        styles,
        metaData: metaD,
      };
      
      const body = JSON.stringify({ elements: [formattedElement] });
      const compressedBody = pako.gzip(body);

      const result:any = await puppeteerService.generateDiagnosisMedicationEducationPdf(compressedBody, isDiagnosis);
       if(result === true)
       {
        setIsPrintPDF(false);
       }
       else{
        setErrorMessage(result);
        onError(result);
        setIsPrintPDF(false);
       }
    } 
    catch (error: any) {
      const errorMsg = `Error: ${error.message || error}`;
      setErrorMessage(errorMsg);
      onError(errorMsg);
      console.error("Error generating PDF:", error);
    } 
    finally {
      setIsPrintPDF(false);
    }
  }, [onError, setIsPrintPDF]);

  return (
    <div>
      {errorMessage && (
          <ProgressLoading
            message={`Something went wrong, please try again later! ${errorMessage}`}
          />
        ) 
      }
      <div
        className="off-screen"
        style={{ position: "absolute", left: "-10000px", top: "0" }}
      >
      <div
        ref={_elementRef}
        style={{
          fontSize: "10px",
          width: "100%",
        }}
        className="blue_theme_social_deter"
      >
        <div
          className="grid-template-pdf new-grid-template-pdf grid-template-pdf-head"
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: "10px",
            marginBottom: "20px",
          }}
        >
          <div className="col-12" style={{ paddingTop: "0px", flex: 1 }}>
            <ul
              className="list-unstyled list-icons-pdf new-list-icons-pdf"
              style={{ marginBottom: "0px" }}
            >
              <li style={{ color: "#000", padding: "0" }}>
                <span
                  style={{ color: "#000", fontSize: "16px", fontWeight: "600" }}
                >
                  {clientDetail?.lName}, {clientDetail?.fName}
                </span>
              </li>
              <li style={{ color: "#000", padding: "0" }}>
                <span style={{ color: "#000", fontSize: "16px" }}>
                  DOB:{" "}
                  {DateTimeHelper.formatDatePickerString(clientDetail?.dob)}
                </span>
              </li>
              {currentInsurance?.insuranceName && (
                <li style={{ color: "#000", padding: "0" }}>
                  <span style={{ color: "#000", fontSize: "16px" }}>
                    {`${currentInsurance?.insuranceName.split("-")[1]}`} -{" "}
                    {`${currentInsurance?.policyNumber}`}
                  </span>
                </li>
              )}
              <li style={{ color: "#000", padding: "0" }}>
                <span style={{ color: "#000", fontSize: "16px" }}>
                  Primary Dx: {minDiagnoseName}
                </span>
              </li>
              <li style={{ color: "#000", padding: "0" }}>
                <span style={{ color: "#000", fontSize: "16px" }}>
                  Program Start Date:{" "}
                  {DateTimeHelper.formatDatePickerString(
                    clientDetail?.dateStart
                  )}
                </span>
              </li>
            </ul>
          </div>
          <div
            className="col-12"
            style={{ paddingTop: "0px", textAlign: "right", flex: 1 }}
          >
            <ul
              className="list-unstyled list-icons-pdf new-list-icons-pdf"
              style={{ marginBottom: "0px" }}
            >
              <li style={{ color: "#000", padding: "0" }}>
                <span
                  style={{
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "600",
                    fontFamily: "Manrope !important",
                  }}
                >
                  {clientDetail?.clinicName}
                  <br />
                </span>
                <span
                  style={{
                    color: "#000",
                    fontSize: "16px",
                    fontFamily: "Manrope !important",
                  }}
                >
                  {(clinicDetails?.address).trim()}
                  <br />
                  {`${clinicDetails?.city}, ${clinicDetails?.state} ${
                    lastZip.length === 0
                      ? intZip + lastZip
                      : intZip + "-" + lastZip
                  }`}{" "}
                  <br />
                  {Phone}
                </span>
              </li>
            </ul>
          </div>
        </div>
        {
            <div className="targetH3" dangerouslySetInnerHTML={{ __html: htmlContentPdf }} />
        }
      </div>
      </div>
    </div>
  );
}

export default DiagnosisEducationPDF;
